// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__3QYKZ","rowsWrapper":"style_rowsWrapper__1WaAB","rowWrapper":"style_rowWrapper__3i8k7"};